import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';


const File5 = () => {
   const [showScrollTop, setShowScrollTop] = useState(false);
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
           useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Programming Languages",
      description: "Master various programming languages including Python, Java, C++, JavaScript, and emerging languages.",
      tags: ["Python", "Java", "C++", "JavaScript", "Go", "Rust"]
    },
    {
      title: "Data Structures & Algorithms",
      description: "Fundamental data structures, algorithm design, complexity analysis, and problem-solving techniques.",
      tags: ["Arrays", "Trees", "Graphs", "Sorting", "Searching", "Optimization"]
    },
    {
      title: "Software Engineering",
      description: "Software development methodologies, design patterns, testing, and project management practices.",
      tags: ["Agile", "Design Patterns", "Testing", "Version Control", "CI/CD"]
    },
    {
      title: "Database Systems",
      description: "Database design, SQL, NoSQL databases, and data management systems for modern applications.",
      tags: ["SQL", "NoSQL", "Database Design", "MongoDB", "PostgreSQL"]
    },
    {
      title: "Artificial Intelligence",
      description: "Machine learning, deep learning, natural language processing, and AI application development.",
      tags: ["Machine Learning", "Deep Learning", "NLP", "Computer Vision", "TensorFlow"]
    },
    {
      title: "Web Development",
      description: "Frontend and backend web development, frameworks, and modern web technologies.",
      tags: ["React", "Node.js", "HTML/CSS", "APIs", "Cloud Services"]
    }
  ];

  const resources = [
    {
      icon: "💻",
      title: "Development Tools",
      description: "IDEs, code editors, debugging tools, and development environments for various programming languages."
    },
    {
      icon: "🌐",
      title: "Online Platforms",
      description: "Coding practice platforms, online judges, and interactive learning environments."
    },
    {
      icon: "📚",
      title: "Documentation",
      description: "Official documentation, API references, and comprehensive programming guides."
    },
    {
      icon: "🚀",
      title: "Project Ideas",
      description: "Hands-on projects, open-source contributions, and portfolio development opportunities."
    }
  ];

  const careerPaths = [
    {
      title: "Software Developer",
      description: "Design, develop, and maintain software applications for various platforms and industries.",
      skills: ["Programming", "Problem Solving", "Software Design", "Testing"]
    },
    {
      title: "Data Scientist",
      description: "Analyze complex data sets, build predictive models, and extract insights for business decisions.",
      skills: ["Python/R", "Statistics", "Machine Learning", "Data Visualization"]
    },
    {
      title: "Full Stack Developer",
      description: "Work on both frontend and backend development, creating complete web applications.",
      skills: ["Frontend Frameworks", "Backend Development", "Databases", "DevOps"]
    },
    {
      title: "AI/ML Engineer",
      description: "Develop artificial intelligence and machine learning solutions for various applications.",
      skills: ["Machine Learning", "Deep Learning", "Python", "Model Deployment"]
    }
  ];

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Computer Science"
      icon="💻"
      color="#FFEAA7"
      description="Journey through programming languages, algorithms, and software development. Discover data structures, artificial intelligence, and the computational thinking that powers our digital age."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>

       <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File5;